<template>
  <div class="item">
        <b-card-group column>
            <b-card
                img-src=""
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 35rem;"
                class="mb-2"
            >
                <div style="display: block; margin: 5px;">
                    <div class="label">PRODUCT NAME</div>
                    <div v-if="edit">
                        <b-form-input v-model="item.product_name"></b-form-input>
                    </div>
                    <div v-else>
                        <span style="font-weight: bold;">{{item.product_name}}</span>
                    </div>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">PRODUCT SKU</div>
                    <div v-if="edit">
                        <b-form-input v-model="item.sku"></b-form-input>
                    </div>

                    <div v-else>
                        <span style="font-weight: bold;">{{item.sku}}</span>
                    </div>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">VENDOR</div>
                    <div v-if="edit">
                        <b-form-select :options="packet.vendors" v-model="item.vendor_id"></b-form-select>
                    </div>
                    <div v-else>
                        <span style="font-weight: bold;">{{packet.vendorsdict[item.vendor_id]}}</span>
                    </div>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">CATEGORY</div>
                    <div v-if="edit">
                        <b-form-select :options="packet.categories" v-model="item.category_id"></b-form-select>
                    </div>
                    <div v-else>
                        <span style="font-weight: bold;">{{packet.categoriesdict[item.category_id]}}</span>
                    </div>
                </div>

                <div style="display: block; margin: 5px;">
                    <span v-if="edit">
                        <b-button size="sm" variant="primary" @click="save_item">SAVE</b-button>
                        <b-button size="sm" variant="danger" @click="edit = false">CANCEL</b-button>
                    </span>
                    <span v-else>
                        <b-button size="sm" @click="edit = !edit">EDIT</b-button>
                    </span>
                </div>
            </b-card>

            <b-card
                img-src=""
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 20rem;"
                class="mb-2"
                
            >
              

                <div style="display: block; margin: 5px;">
                    <div class="label">WHOLESALE PRICE</div>
                    <div v-if="edit">
                        <b-form-input type="number" v-model="item.wholesale_price"></b-form-input>
                    </div>
                    <div v-else>
                        <span style="font-weight: bold;">$ {{ (item.wholesale_price || 0.0).toFixed(2) }}</span>
                    </div>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">LANDED COST</div>
                    <div v-if="edit">
                        <b-form-input type="number" v-model="item.landed_cost"></b-form-input>
                    </div>
                    <div v-else>
                        <span style="font-weight: bold;">$ {{ (item.landed_cost || 0.0).toFixed(2) }}</span>
                    </div>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">FOB</div>
                    <div v-if="edit">
                        <b-form-input type="number" v-model="item.fob_price"></b-form-input>
                    </div>
                    <div v-else>
                        <span style="font-weight: bold;">$ {{ (item.fob_price || 0.0).toFixed(2) }}</span>
                    </div>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">CUBES</div>
                    <div v-if="edit">
                        <b-form-input type="number" v-model="item.cubes"></b-form-input>
                    </div>
                    <div v-else>
                        <span style="font-weight: bold;">{{ (item.cubes || 0.0).toFixed(2) }}</span>
                    </div>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">SPIFF</div>
                    <div v-if="edit">
                        <b-form-input type="number" v-model="item.spiff"></b-form-input>
                    </div>
                    <div v-else>
                        <span style="font-weight: bold;">{{ (item.spiff || 0.0).toFixed(2) }}</span>
                    </div>
                </div>

                <!-- <div style="display: block; margin: 5px;">
                    <span v-if="edit">
                        <b-button size="sm" variant="primary" @click="save_item">SAVE</b-button>
                        <b-button size="sm" variant="danger" @click="edit = false">CANCEL</b-button>
                    </span>
                    <span v-else>
                        <b-button size="sm" @click="edit = !edit">EDIT</b-button>
                    </span>
                </div> -->
            </b-card>

            <b-card
                img-src=""
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 15rem;"
                class="mb-2"
            >
                <div style="display: block; margin: 5px;">
                    <div class="label">AVAILABLE</div>
                    <span style="font-weight: bold;"> {{ item.available }}</span>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">RESERVED</div>
                    <span style="font-weight: bold;"> {{ item.reserved }}</span>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">SOLD SO FAR</div>
                    <span style="font-weight: bold;"> {{ item.sold_so_far }}</span>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">LAYAWAYED</div>
                    <span style="font-weight: bold;"> {{ item.layawayed }}</span>
                </div>
            </b-card>

            <b-card
                img-src=""
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 10rem;"
                class="mb-2"
            >
                <div style="display: block; margin: 5px;">
                    <div class="label">ETA 1</div>
                    <span style="font-weight: bold;">2020-01-01</span>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">ETA 2</div>
                    <span style="font-weight: bold;">2020-01-01</span>
                </div>

                <div style="display: block; margin: 5px;">
                    <div class="label">ETA 3</div>
                    <span style="font-weight: bold;">2020-01-01</span>
                </div>
            </b-card>


            <b-card
                img-src=""
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 10rem;"
                class="mb-2"
            >
                
                <div style="display: block; margin: 5px;">
                    <span v-if="edit">
                        <div style="display: block; margin: 5px;">
                            <b-button variant="success" @click="update_product">SAVE</b-button>
                        </div>

                        <div style="display: block; margin: 5px;">
                            <b-button  variant="warning" @click="edit = false">CANCEL</b-button>
                        </div>
                    </span>
                    <span v-else>
                        <div style="display: block; margin: 5px;">
                            <b-button variant="primary" @click="edit = !edit">EDIT</b-button>
                        </div>
                    </span>

                    <div style="display: block; margin: 5px;" v-if="item.sold_so_far == 0 && packet.userDetails.userrole == 'admin'">
                        <b-button variant="danger" @click="delete_product">DELETE</b-button>
                    </div>
                </div>
            </b-card>
        </b-card-group>
    </div>
</template>

<script>
export default {
    name: "Product",
    // props: {
    //     index: { // index of current item
    //         type: Number
    //     },
    //     source: {
    //         type: Object,
    //         default() {
    //             return {}
    //         }
    //     }
    // }
    props: ["viewdata"],
    data: function(){
        return {
            item: {},
            packet: {
                vendorsdict: {},
                vendors: [],
                categoriesdict: {},
                categories: [],
                userDetails: {}
            },
            edit: false,
        }
    },
    methods: {
        update_product: function(){
            let product = this.item;
            let path = "/api/product/update_v1/"
            let data = product;
            data["properties"] = {
                "spiff": parseFloat(data.spiff),
                "cubes": parseFloat(data.cubes),
            }
            let that = this;
            let s = function(response){
                if (response.data.result){
                    that.$bvToast.toast(
                        "Updated product.", 
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                    product.edit = !product.edit;
                }
                else {
                    that.$bvToast.toast(
                        response.data.error, 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                that.edit_product_idx = null
                
            }
            let f = function(error){
                console.log(error)
                that.$bvToast.toast(
                    "Error updating product.",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
                that.edit_product_idx = null   
                product.edit = !product.edit;
            }
            Requestor.postAsyncP(path, data, this, s, f);

        },
        delete_product: function(){
            let product = this.item;
            let path = "/api/product/delete_v1/"
            let data = product;
            let that = this;
            let s = function(response){
                if(response.data.error) {
                    that.$bvToast.toast(
                        response.data.error, 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                else {
                    that.$bvToast.toast(
                        "deleted product.", 
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                    //product.edit = !product.edit;
                    that.fetch_init()
                }
                that.edit_product_idx = null
            }
            let f = function(error){
                console.log(error)
                that.$bvToast.toast(
                    "Error updating product.",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
                that.edit_product_idx = null   
                product.edit = !product.edit;
            }
            Requestor.postAsyncP(path, data, this, s, f);

        },
    },
    created: function(){
        this.item = this.viewdata.item;//JSON.parse(JSON.stringify(i))
        this.packet = this.viewdata.packet;
    }
}
</script>

<style scoped>
.item {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid lightgrey;
    padding: 1em;
}

.label {
    border-bottom: 1px dashed; 
    width: auto; 
    margin: 3px; 
    font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Products/Product.vue